import React, { useState } from "react";
import "./Resume.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import WorkExperience from "./WorkExperience";
import Button from "./Button";

const Resume = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <section className="resume container section" id="resume">
      <h2 className="section__title">Skills & Expertise</h2>

      <div className="resume__container">
        <Tabs
          className="tabs"
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
          selectedTabClassName={"is-active"}
          selectedTabPanelClassName={"is-active"}
        >
          <TabList className="tab__list">
            {WorkExperience.map((skill) => (
              <Tab className="tab" key={skill.id}>
                <Button>{skill.category}</Button>
              </Tab>
            ))}
          </TabList>

          {WorkExperience.map((skill) => (
            <TabPanel className="tab__panel" key={skill.id}>
              <ul className="tab__panel-list">
                {skill.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default Resume;
